import type { PieceLogoBase } from '@seddi/scene';
import { PropsDiff } from '../core/reconciler/propsDiff';
import {
  type PieceLogoRenderable,
  attachLogo,
  updateSide,
  updateTransform,
} from '../renderables/pieceLogoRenderable';
import { findLogo } from '../scene/scene';
import type { SceneReconcilerFrame } from './sceneReconcilerFrame';

/**
 * Update logo.
 * @param renderable - Renderable.
 * @param nextProps - Piece logo next.
 * @param prevProps - Piece logo prev.
 * @param frame - Reconciler frame.
 */
export const update = (
  renderable: PieceLogoRenderable,
  nextProps: PieceLogoBase,
  prevProps: PieceLogoBase | undefined,
  frame: SceneReconcilerFrame,
): boolean => {
  const { nextScene, resources } = frame;

  const diffProps = PropsDiff.diff(nextProps, prevProps);
  let dirty = false;

  // update resource or technique
  if (['resource', 'technique'].some((key) => diffProps.includes(key))) {
    const id = nextProps.resource;

    if (resources.findLogo(id)) {
      attachLogo(renderable, nextProps, resources);
      dirty = true;
    } else {
      if (!resources.hasLogoRequest(id)) {
        const l = findLogo(nextScene, id);
        resources.loadLogoDeferred(l);
      }
    }
  }

  // Update side.
  if (diffProps.includes('side')) {
    updateSide(renderable, nextProps.side);
    dirty = true;
  }

  // Update transform.
  if (['side', 'size', 'transform'].some((key) => diffProps.includes(key))) {
    updateTransform(renderable, nextProps);
    dirty = true;
  }

  return dirty;
};
